export const PRIMARY_COLOR = '#0380cf';
export const SECONDARY_COLOR = '#ffb401';
export const MAIN_TEXT_COLOR = '#000060';
export const GREY_TEXT_COLOR = '#6E6E6E';
export const NEUTRAL_COLOR = '#ebf3ff';
export const WHITE = '#fff';
export const BLACK = '#000';
